
<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
          <v-row class="d-flex justify-center mt-3">
              <v-col cols="3">
                  <v-text-field
                  label="Nome da Função"
                  v-model="form.filters.funcao"
                  outlined
                  dense
                  ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-select
                  label="Tipo de Profissional"
                  :items="[
                    { label: 'Servidor do Estado de Pernambuco', value: 0 },
                    { label: 'Profissional externo', value: 1 },
                  ]"
                  :item-text="'label'"
                  :item-value="'value'"
                  v-model="form.filters.tipoProfissional"
                  outlined
                  dense
                ></v-select>
              </v-col>
              <sca-select-ativo
                :cols="2"
                :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
                v-model="form.filters.situacao"
              ></sca-select-ativo>
          </v-row>
          <v-row class="d-flex justify-center mt-3">
            <sca-date-picker
              :cols="2"
              label="Data Início"
              v-model="form.filters.dataInicio"
              removeIcon
              outlined
              dense
            ></sca-date-picker>
            <sca-date-picker
            :cols="2"
              v-model="form.filters.dataFim"
              label="Data Final"
              removeIcon
              outlined
              dense
            ></sca-date-picker>
          </v-row>
           <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarRelatorios"
            ></sca-tooltip>
            <sca-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5 printable"
        :headers="headersAnalitico"
        :items="form.lists.listRelatorios"
        :items-per-page="10"
        :footer-props="$footerProps"
        show-expand
        sort-by="dataAcao"
        :sort-desc="true"
        item-key="id"
        :expanded.sync="expanded"
      >
        <template v-slot:[`item.funcao`]="{ item }">
          {{ item.funcao }}
        </template>
        <template v-slot:[`item.tipoProfissional`]="{ item }">
          {{ item.tipoProfissional }}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="resposta" :colspan="headers.length">
            <div class="resposta-conteudo">
              {{ item.atividade.nome }}
            </div>
          </td>
        </template>


        <template v-slot:[`item.situacao`]="{ item }">
          <sca-label-ativo :ativo="item.situacao" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.dataAcao`]="{ item }">
          {{ $formatarDataHora(item.dataAcao) }}
        </template>
        <template v-slot:[`item.acao`]="{ item }">
          {{ item.acao }}
        </template>
      </v-data-table>
      <sca-buttons
        v-if="form.lists.listRelatorios.length"
        actionText="Baixar PDF"
        cancelText="Baixar CSV"
        @click="baixarRelatorioPdf"
        @cancel="baixarCSVRelatorio"
      ></sca-buttons>
    </v-container>
  </div>
</template>

<script>
  import pageLoadingMixin from "mixins/page-loading.mixin";
  import RelatorioDeLog from "services/relatorios-log/manter-funcao-log.service"
  export default {
      name: "RelatorioLogFuncao",
      mixins: [pageLoadingMixin, RelatorioDeLog],

      data: () => ({
      onReport: false,
      expanded: [],
      form: {
          filters: {
              funcao: null,
              tipoProfissional: null,
              situacao: null,
              dataInicio: null,
              dataFim: null,
          },
          lists: {
              listRelatorios: [],
          },
      },
      headersAnalitico: [
          { text: "Nome da Função", align: "center", value: "funcao" },
          { text: "Tipo de Profissional", align: "center", value: "tipoProfissional" },
          { text: "Atividades", align: "center", value: "data-table-expand"},
          { text: "Situação", align: "center", value: "situacao" },
          { text: "Data/Hora da ação", align: "center", value: "dataAcao" },
          { text: "Ação", align: "center", value: "acao" },
      ],
      }),
      methods: {
      async buscarRelatorios() {
          const isValid = this.validarDatas();
          if (!isValid) return;
          if (!this.verificarFiltrosPreenchidos()) return;
          this.showPageLoading();
          try {
          const { data } = await this.$obterRelatorioLogFuncao({ params: this.form.filters });
          this.processarRespostaRelatorio(data);
          } finally {
          this.hidePageLoading();
          }
      },
      validarDatas() {
      const { dataInicio, dataFim } = this.form.filters;

      if (dataInicio && dataFim) {
        if (new Date(dataFim) < new Date(dataInicio)) {
          this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
          return false;
        }
        if (new Date(dataInicio) > new Date(dataFim)) {
          this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
          return false;
        }
      }
      return true;
    },

    verificarFiltrosPreenchidos() {
      const { funcao, tipoProfissional, situacao, dataInicio, dataFim } = this.form.filters;
      if (!funcao && tipoProfissional == null && situacao == null && !dataInicio && !dataFim) {
        this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
        return false;
      }
      return true;
    },

      async baixarCSVRelatorio() {
        this.showPageLoading();
        try {
        const { data } = await this.$obterRelatorioLogCSVFuncao({ params: this.form.filters });
        this.$baixarRelatorioCSV(data, `SCA.RelatórioDeLogDeFunçãoCSV`);
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
        }
      },

      async baixarRelatorioPdf() {
        this.showPageLoading();
        try {
        const { data } = await this.$obterRelatorioLogPDFFuncao({ params: this.form.filters });
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SCA.RelatórioDeLogDeFunção.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
        }
      },

      processarRespostaRelatorio(data) {
        this.form.lists.listRelatorios = data.lista;
      },

      resetForm() {
        this.form.filters.dataInicio = null;
        this.form.filters.dataFim = null;
        this.form.filters.tipoProfissional = null;

        this.$nextTick(() => {
          this.$set(this.form.filters, 'dataInicio', null);
          this.$set(this.form.filters, 'dataFim', null);
        });
        this.form.filters.funcao = null;
        this.form.filters.situacao = null;
        this.form.filters.tipoProfissional = null;

        this.form.lists.listRelatorios = [];
        this.expanded = [];
      }
    },
  };
</script>
<style scoped>
  .resposta {
    padding: 1em !important;
    text-align: left;
  }

  .resposta-conteudo {
    font-weight: bold;
    padding: 0.8rem;
    border-radius: 3px;
    line-height: 1.4;
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    max-width: 100%;
    font-size: 0.95rem;
    margin: 0.5rem 0;
  }
</style>
